import { publishEvent } from '@zet/analytics'
import { PressableWithIntent } from '@zet/common/components/pressableWithIntent'
import { BTN_LG, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { navigationRef } from '@zet/utils/navigation'

import { useBrandDetailsById } from '../../../api/brands/hooks'

interface CrossSellingBottomSheetButtonProps {
  isEligibleCard: boolean
  currentBrandName: string
  crossSellingBrandName: string
  handlePress: () => void
  customerPhoneNumber: number
  customerId: number
  brandId: string
  customerName: string
}

const CrossSellingBottomSheetButton = ({
  isEligibleCard,
  currentBrandName,
  crossSellingBrandName,
  handlePress,
  customerPhoneNumber,
  customerId,
  customerName,
  brandId,
}: CrossSellingBottomSheetButtonProps) => {
  const { data: brandContent } = useBrandDetailsById(brandId || '')
  const leadSourceCreditCardCrossSelling = isEligibleCard
    ? 'cross_nonapi_listing_bdp'
    : 'cross_nonapi_rec_bdp'
  const onButtonClick = () => {
    navigationRef.navigate('BrandDetails', {
      brandId: brandId,
      customerName: customerName,
      customerPhoneNumber: customerPhoneNumber,
      customerId: customerId,
      isEligible: true,
      leadSource: leadSourceCreditCardCrossSelling,
    })
    publishEvent('click_action', {
      item_name: isEligibleCard
        ? 'cross-nonapi-continue-secondary'
        : 'cross-nonapi-continue',
      brand_name: brandContent?.name,
      brand_category: brandContent?.subCategory,
    })
  }

  const onhandleBrandShare = () => {
    handlePress()
    publishEvent('click_action', {
      item_name: 'cross-nonapi-continue-primary',
      brand_name: currentBrandName,
    })
  }

  return (
    <Stack>
      <PressableWithIntent
        name="creditCardCrossselling"
        opacity
        fullWidth
        className={`${
          !isEligibleCard ? 'bg-primary-10' : 'bg-primary-100'
        } m-3 h-[60] items-center justify-center rounded-md`}
        onPress={onButtonClick}
      >
        <BTN_LG
          className={`${
            !isEligibleCard ? 'text-primary-100' : 'text-neutral-white100'
          }`}
        >
          {i18n.t('creditCardCrossSelling.bottomSheetButtonText', {
            brandName: crossSellingBrandName,
          })}
        </BTN_LG>
      </PressableWithIntent>
      {isEligibleCard ? (
        <PressableWithIntent
          name="creditCardCrossselling"
          opacity
          fullWidth
          className="bg-primary-10 m-3 h-[60] items-center justify-center rounded-md"
          onPress={onhandleBrandShare}
        >
          <BTN_LG className="text-primary-100">
            {i18n.t('creditCardCrossSelling.bottomSheetShareButtonText', {
              brandName: currentBrandName,
            })}
          </BTN_LG>
        </PressableWithIntent>
      ) : null}
    </Stack>
  )
}

export default CrossSellingBottomSheetButton
